import React, { Component, Fragment } from 'react';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import EditIncidentDialog from '../pages/editIncidentEmail/EditIncidentDialog';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';
import LZString from 'lz-string';


class EditIncidentEmailConfig extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const userInfo = JSON.parse(decompressedData) 
    const menu = userInfo['moduleAccess'];
    let userID = userInfo['userId'];
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    let year = date.getFullYear();

    var daynow = new Date();

    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: 'Edit Incident Email Config',

      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      user: menu,
      pageAllowed: false,
      editing: false,
      userID: userID,
      proxyjson: [],
      editData: [],
      loading: false,
      someD: false,
      someS: 'meaning',
      submittedBy: '',
      editing: false,
    };
  }

  handleEdit = () => {
    this.setState({
      editing: true,
    });
  };
  updateUser = (id, cityLeaders, legal, operationHead) => {
    const addData = {
      emailCityLeader: cityLeaders,
      emailConfigId: id,
      emailLegal: legal,
      emailOpsTeam: operationHead,
      userId: this.state.userID,
    };
    this.setState({
      editing: false,
    });
    ApiGateWay.Post(
      this.state.apiInterface + '/saveIncidentAlertConfig',
      addData
    )
      .then((response) => response.json())
      .then((response) => {
        toast.success('Email Incidebts Updated Successfully!');
        this.setState({
          editing: false,
        });
        window.location.reload(false);
        this.onLoadEmail();
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  onLoadEmail = () => {
    ApiGateWay.Get(this.state.apiInterface + '/fetchIncidentAlertConfig')
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        this.setState({
          editData: response,
          someD: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };
  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? val.featureAccess
          ? val.featureAccess.map((child1, ind) =>
              child1.featureName == 'Edit Incident Email Config'
                ? (pageAllow = true)
                : ''
            )
          : ''
        : ''
    );

    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: false,
      });
      ApiGateWay.PostEmp(this.state.apiInterface + '/fetchEmpInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            submittedByCodeJson: response,
            visible: true,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
      this.onLoadEmail();
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }
  render() {
    const { loading, modalOpen, pageAllowed, message, someD } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'Edit Incident Email Config'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
        
          <Navigate to="/pageNotAllowed" state={{ id:'Edit Incident Email Config' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content' style={{ width: '95%' }}>
                <div className='row backgr-custom' style={{overflowX:'auto'}}>
                  <ToastContainer
                    position='top-right'
                    autoClose={4000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    className=''
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                  <div>
                    {!someD ? (
                      <Spinner />
                    ) : (
                      <table
                        className='table table-bordered table-hover table-striped '
                        style={{
                          borderCollapse: 'collapse',
                        }}
                      >
                        <thead
                          className=''
                          style={{
                            backgroundColor: '#3c8dbc',
                            color: '#fff',
                          }}
                        >
                          <tr>
                            <th>Store</th>
                            <th>Zone</th>
                            <th>Alert</th>
                            <th>City Leaders</th>
                            <th>Legal</th>
                            <th>Operation Head</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className='mms'>
                          {this.state.editData.incidentAlertInfo
                            ? this.state.editData.incidentAlertInfo.map(
                                (usr) => {
                                  return (
                                    <tr key={usr.emailConfigId}>
                                      <td>{usr.storeType}</td>
                                      <td>{usr.zone}</td>
                                      <td>{usr.alertType}</td>
                                      <td>
                                        {usr.emailCityLeader
                                          .split(',')
                                          .join(', ')}
                                      </td>
                                      <td>
                                        {usr.emailLegal.split(',').join(', ')}
                                      </td>
                                      <td>
                                        {usr.emailOpsTeam.split(',').join(', ')}
                                      </td>
                                      <td>
                                        <Fragment>
                                          <EditIncidentDialog
                                            storeType={usr.storeType}
                                            editing={this.state.editing}
                                            updateUser={this.updateUser}
                                            zone={usr.zone}
                                            configId={usr.emailConfigId}
                                            alertType={usr.alertType}
                                            emailCityLeader={
                                              usr.emailCityLeader
                                            }
                                            emailLegal={usr.emailLegal}
                                            emailOpsTeam={usr.emailOpsTeam}
                                          />
                                        </Fragment>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            : null}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default EditIncidentEmailConfig;
